import { KNOWN_HOSTS, DEFAULT_HOST } from '../config.js';

// 从传入的字符串（如 window.imUrl 或 window.location.host）中提取日域名
export function extractDailyDomain(rawHost) {
  if (!rawHost || typeof rawHost !== 'string') return '';
  // 移除协议头与路径
  let clean = rawHost.replace(/^[a-zA-Z]+:\/\//, '').split('/')[0].trim();
  // 移除端口号（如 :8443，不需要端口号）
  clean = clean.split(':')[0];

  if (!clean || clean === 'localhost' || clean === '127.0.0.1' || clean.endsWith('.local') || /^\d+\.\d+\.\d+\.\d+$/.test(clean)) {
    return '';
  }

  const parts = clean.split('.');
  if (parts.length >= 3) {
    // 例如 w3.c62c44ce3008.top -> c62c44ce3008.top
    return parts.slice(1).join('.');
  } else if (parts.length === 2) {
    return clean;
  }
  return '';
}

// Detect server address from window.imUrl or URL
export function detectServerAddress() {
  if (typeof window === 'object') {
    const raw = window.imUrl || (window.location && (window.location.hostname || window.location.host)) || '';

    if (!window.imUrl && window.location && (window.location.protocol === 'file:' || window.location.hostname === 'localhost')) {
      return KNOWN_HOSTS.local;
    }

    const daily = extractDailyDomain(raw);
    if (daily) {
      // 组装成 wss 地址：ns.日域名（不带端口号）
      return `ns.${daily}`;
    }

    if (window.location && window.location.hostname) {
      return window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    }
  }
  return DEFAULT_HOST;
}

// Detect if the page is served over HTTPS or WSS.
export function isSecureConnection() {
  if (typeof window === 'object') {
    if (window.imUrl) {
      return true;
    }
    const raw = (window.location && (window.location.hostname || window.location.host)) || '';
    const daily = extractDailyDomain(raw);
    if (daily) {
      return true; // ns.日域名 走 wss
    }
    if (window.location && window.location.protocol) {
      return window.location.protocol === 'https:';
    }
  }
  return false;
}

export function isLocalHost() {
  if (typeof window === 'object' && window.location) {
    return window.location.hostname === 'localhost';
  }
  return false;
}
